"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAlertState = void 0;
var UserSearchSet_init_1 = require("@/pages/common/states/UserSearchSet.init");
exports.defaultAlertState = {
    nameTitle: 'Alerts',
    nameCaption: 'Manage update notification from Saved Searches that you are following',
    savedSearches: UserSearchSet_init_1.defaultUserSearchSets,
    followingPlaces: [UserSearchSet_init_1.defaultUserSearchSetFollowDistrictType],
    marketUpdate: false,
    unsubscribeMode: false,
    isLoading: false,
    t: {
        off: 'Off',
        daily: 'Daily',
        weekly: 'Weekly',
        updateFromYour: 'Update from your saved searches',
        updateFromFollows: 'Update from your following places',
        savedSearchCriteria: 'Saved Search Criteria',
        emailUpdatesEnabled: 'Email Updates Enabled',
        communicationFrom: 'Communication from OKAY.com',
        marketUpdate: 'Market Update',
        generalNews: 'General News',
        save: 'Save',
        emptyTitle: 'No saved search yet!',
        emptyTitleFollow: 'No following Places yet!',
        emptyCaption: 'Your saved search criterias will be shown here',
        emptyCaptionFollow: 'Your following places will be shown here',
        emptyStartNew: 'You can start a new search and click `Save Search` to begin with',
        emptyStartNewFollow: 'You can checkout a building and click `Follow` to begin with',
        emptySearchNow: 'Start a new search now',
        email: 'Email',
        mobile: 'Mobile',
        frequency: 'Frequency',
        unsubscribeTitle: 'Unsubscribe from OKAY.COM',
        unsubscribeCaption: 'You can disable all notifications from us',
        unsubscribeButton: 'Unsubscribe',
    },
};
